import { SxProps, Theme } from '@mui/material';
import { commonStyles } from '~/theme/styles/commonStyles.ts';

type TStyles = {
  buttonBox: SxProps<Theme>;
  wrapper: SxProps<Theme>;
  titleInfo: SxProps<Theme>;
  additionalInfoModal: SxProps<Theme>;
  modalContainer: SxProps<Theme>;
  modalContent: SxProps<Theme>;
  textFieldError: SxProps<Theme>;
  table: SxProps<Theme>;
};

export const styles: TStyles = {
  buttonBox: {
    display: 'flex',
    justifyContent: 'center',
  },

  wrapper: (theme: Theme) => ({
    backgroundColor: 'var(--main-color-with-opacity-03)',
    padding: '30px 25px',
    marginBottom: '20px',
    borderRadius: '10px',
    border: `1px solid ${theme.palette.grey.additionalGrey}`,
    boxShadow: '2px 2px 10px 0 var(--additional-dark-gray-with-opacity-eight)',
  }),

  titleInfo: {
    padding: '10px 0 30px 0',
    textAlign: 'center',
  },

  additionalInfoModal: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '10px',
  },

  modalContainer: (theme: Theme) => ({
    ...(commonStyles.scroll(theme) as Object),
    zIndex: 2,
    width: '80%',
    overflowX: 'hidden',
  }),

  modalContent: (theme: Theme) => ({
    color: theme.palette.text.primary,
    textAlign: 'justify',
  }),

  textFieldError: (theme: Theme) => ({
    width: '100%',
    color: theme.palette.error.main,
    fontSize: '10px',
    minHeight: '14px',
    maxHeight: '14px',
    position: 'relative',
  }),

  table: (theme: Theme) => ({
    ...(commonStyles.scroll(theme) as Object),
    ...(commonStyles.scrollWithBorder(theme) as Object),
    width: '100%',
    overflow: 'auto',
    mt: '10px',
    background: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey[100]}`,
    [theme.breakpoints.down('md')]: {
      background: 'transparent',
      border: 'none',
    },
  }),
};
